import { render, staticRenderFns } from "./MyCarDetailActivityDetails.vue?vue&type=template&id=570d9e6d&scoped=true&"
import script from "./MyCarDetailActivityDetails.vue?vue&type=script&lang=js&"
export * from "./MyCarDetailActivityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d9e6d",
  null
  
)

export default component.exports